var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboardArkc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8251 25.8996L14.1617 20.2623L17.4675 23.5651L11.8251 25.8996ZM19.4359 24.9054L20.7355 21.7537L15.8992 16.9277L12.7426 18.2361L10.2727 15.7665L25.3389 10L27.7273 12.3861L21.9655 27.4545L19.4359 24.9054Z",
    fill: "#909090"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardArkc);
export default __webpack_public_path__ + "static/media/dashboard-arkc.986238c7a24baf819513677239472cb5.svg";
export { ForwardRef as ReactComponent };